'use strict';

import type { GlobUserTemplate } from '../../Entities/Glob/GlobUserTemplate';
import { EntityCollection } from '../EntityCollection';

export class GlobUserTemplateCollection extends EntityCollection<GlobUserTemplate> {}
